export const StatCard = ({ label, value, sub, icon: Icon, accent = "#2540FF", testid }) => (
  <div className="bg-white rounded-2xl border border-slate-200 p-5 animate-fade-up" data-testid={testid}>
    <div className="flex items-start justify-between">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</p>
      {Icon && (
        <div className="h-9 w-9 rounded-xl flex items-center justify-center" style={{ background: `${accent}15` }}>
          <Icon className="h-[18px] w-[18px]" style={{ color: accent }} />
        </div>
      )}
    </div>
    <p className="mt-3 text-3xl font-bold font-head text-ccc-navy">{value}</p>
    {sub && <p className="mt-1 text-xs text-slate-500">{sub}</p>}
  </div>
);
